import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FooterServiceNav from "./FooterServiceNav";
import serviceData from "../../components/services/services-one/ServicesOneData.json";

const Footer = ({ siteSettings }) => {
  const [socialLinks, setSocialLinks] = useState(null);

  console.log("")
  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
          "https://rss.fastwebforge.com/api/social-links"
        );
        const data = await response.json();
        setSocialLinks(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);

  let heroSection = null;
  if (socialLinks && socialLinks.data && socialLinks.data) {
    heroSection = socialLinks.data[4];
  }
  const facebook = heroSection ? heroSection.site_url : " ";

  if (socialLinks && socialLinks.data && socialLinks.data) {
    heroSection = socialLinks.data[3];
  }
  const twitter = heroSection ? heroSection.site_url : " ";

  if (socialLinks && socialLinks.data && socialLinks.data) {
    heroSection = socialLinks.data[2];
  }
  const instragram = heroSection ? heroSection.site_url : " ";

  if (socialLinks && socialLinks.data && socialLinks.data) {
    heroSection = socialLinks.data[1];
  }
  const yoytube = heroSection ? heroSection.site_url : " ";

  if (socialLinks && socialLinks.data && socialLinks.data) {
    heroSection = socialLinks.data[0];
  }
  const linkedIn = heroSection ? heroSection.site_url : " ";
  return (
    <>
      {/* footer Section Start */}
      <footer>
        {/* footer Top Section Start */}
        <div className="footer-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="logo">
                  <Link to="/">
                    <img
                      src={
                        siteSettings && siteSettings.data
                          ? siteSettings.data.logo
                          : "/images/no-image.png"
                      }
                      width={200}
                      height={20}
                      alt="Logo"
                    ></img>
                  </Link>
                </div>
                <div className="footer-wedget-one">
                  <p className="footer-item">
                    {siteSettings && siteSettings.data
                      ? siteSettings.data.description
                      : ""}
                  </p>
                  <div className="footer-social-profile">
                    <ul>
                      <li>
                        <a href={facebook} target="_blank">
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href={twitter} target="_blank">
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                      {/* <li>
                    <a href={instragram} target="_blank">
                      <i className="fa fa-pinterest" />
                    </a>
                  </li> */}
                      {/* <li>
                    <a href={yoytube} target="_blank">
                      <i className="fa fa-google-plus" />
                    </a>
                  </li> */}
                      {/* <li>
                    <a href={linkedIn}>
                      <i className="fa fa-vimeo" />
                    </a>
                  </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Service links</h2>
                  <ul>
                    {serviceData.map((item) => (
                      <FooterServiceNav key={item.id} data={item} />
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Support links</h2>
                  <ul>
                    {/* <li>
                      <a href="#">support link</a>
                    </li>
                    <li>
                      <a href="#">faq &amp; help center</a>
                    </li> */}
                    <li>
                      <a href="#">about us</a>
                    </li>
                    <li>
                      <a href="#">Employees</a>
                    </li>
                    {/* <li>
                      <a href="#">service and help</a>
                    </li> */}
                    <li>
                      <a href="#">Contact Us</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-wedget-four">
                  <h2>contact us </h2>
                  <div className="inner-box">
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-map-marker" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {siteSettings && siteSettings.data
                              ? siteSettings.data.address
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-envelope-o" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {siteSettings &&
                            siteSettings.data &&
                            siteSettings.data.email ? (
                              <a
                                href={`mailto:${siteSettings.data.email}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {siteSettings.data.email}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-envelope-o" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {siteSettings &&
                            siteSettings.data &&
                            siteSettings.data.offices[0] && siteSettings.data.offices[0].email ? (
                              <a
                                href={`mailto:${siteSettings.data.offices[0].email}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {siteSettings.data.offices[0].email}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-phone" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {siteSettings &&
                            siteSettings.data &&
                            siteSettings.data.phone ? (
                              <a
                                href={`tel:${siteSettings.data.phone}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {siteSettings.data.phone}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Top Section End */}
        {/* footer Bottom Section Start */}
        <div className="footer-bottom-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="copy-right">
                  <p>
                    © Copyright 2025{" "}
                    <span>
                      <a href="#">RSS Security and Investigations Pty Ltd.</a>
                    </span>{" "}
                    <span> to deliver the protection you deserve!</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Bottom Section End */}
      </footer>
      {/* footer Section End */}
    </>
  );
};

export default Footer;
